module.exports = __webpack_public_path__ + "static/media/e6.cb25eb49.png";